import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  space-between;
  padding: 30px 0;
`;

export const Left = styled.div`
  width: 33%;
  padding: 20px;
`;

export const Image = styled.img`
  margin-top: 46px;
  width: 100%;
`;

export const Right = styled.div`
  width: 66%;
`;



// WEBPACK FOOTER //
// ./src/containers/Home/Company/styles.js